var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgHideEye = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4.84689C7.41454 4.84689 3.25621 7.35563 0.187788 11.4305C-0.0625959 11.7643 -0.0625959 12.2307 0.187788 12.5646C3.25621 16.6444 7.41454 19.1531 12 19.1531C16.5855 19.1531 20.7438 16.6444 23.8122 12.5695C24.0626 12.2357 24.0626 11.7693 23.8122 11.4354C20.7438 7.35563 16.5855 4.84689 12 4.84689ZM12.3289 17.0371C9.28506 17.2286 6.7714 14.7198 6.96287 11.6711C7.11998 9.15741 9.15741 7.11997 11.6711 6.96287C14.7149 6.7714 17.2286 9.28014 17.0371 12.3289C16.8751 14.8377 14.8377 16.8751 12.3289 17.0371ZM12.1767 14.71C10.537 14.8131 9.18196 13.463 9.28997 11.8233C9.37343 10.4682 10.4732 9.37343 11.8282 9.28505C13.4679 9.18196 14.823 10.5321 14.7149 12.1718C14.6266 13.5318 13.5268 14.6266 12.1767 14.71Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.7847,
    y1: 1.25742,
    x2: 5.42863,
    y2: 21.8323,
    stroke: "#989898"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHideEye, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hide-eye.7fc1da72.svg";
export { ForwardRef as ReactComponent };